/**
 * The replaceDate method can be used to format date string.
 *
 * We can input into the method format and date strings, for example:
 * @param format{string} - "DD/MM/YYYY", "DD-MM-YYYY", "hh:mm:ss"
 * @param date{string} - "Mon Apr 16 2018 10:46:23 GMT+0300 (FLE Summer Time)"
 * and the method will replace and return
 * "dd" with 16, "mm" with 04 and "yyyy" with 2018
 * @return{string} "16/04/2018", "16-04-2018"
 *  or
 * "hh" with 10, "mm" with 46 and "ss" with 23
 * @return{string} "10:46:23"
 *
 * Custom date format
 * DDD - weekday
 * DD = month day
 * MMM - month name
 * MM - number of month
 * YYYY - year
 * hh - hours
 * mm - minutes
 * ss - seconds
 */
export function replaceDate(format, date) {
    var givenDate = new Date(date);
    var replaceD = format.replace("DDD", getNameDate(givenDate, 0))
        .replace("MMM", getNameDate(givenDate, 1))
        .replace("DD", givenDate.getDate().toString())
        .replace("MM", givenDate.getMonth().toString())
        .replace("YYYY", givenDate.getFullYear().toString())
        .replace("hh", givenDate.getHours().toString())
        .replace("mm", givenDate.getMinutes().toString())
        .replace("ss", givenDate.getSeconds().toString());
    return replaceD;
}
;
function getNameDate(date, n) {
    var dateArr = date.toDateString().split(" ");
    return dateArr[n];
}
;
//# sourceMappingURL=DateFormat.js.map